export default "__VITE_ASSET__CU4ys53b__"